import React, { useState } from 'react'

/**
 * Modelo genérico do quadro de Gestão de atividades.
 * Colunas, contagem, incluir na primeira, cartão com alça e arraste.
 * Campos de atividade (projeto, tarefa, natureza) ficam de fora.
 */

const COLUNAS = [
  { id: 'nao', nome: 'Não iniciado', inclui: true },
  { id: 'ini', nome: 'Iniciado' },
  { id: 'fim', nome: 'Concluído' },
]

const INICIO = [
  { id: '1', coluna: 'nao', titulo: 'Relatório de campo', linha: 'Ana Souza' },
  { id: '2', coluna: 'nao', titulo: 'Vistoria', linha: 'Sem responsável' },
  { id: '3', coluna: 'ini', titulo: 'Mapa de uso do solo', linha: 'Pedro Lima' },
  { id: '4', coluna: 'fim', titulo: 'Levantamento fotográfico', linha: 'Marina Costa' },
]

export default function ErpKanban() {
  const [itens, setItens] = useState(INICIO)
  const [sobre, setSobre] = useState('')
  const [marca, setMarca] = useState(null)
  const [aberta, setAberta] = useState('')
  const arrastando = React.useRef('')

  function mover(id, coluna, antesDe) {
    setItens((lista) => {
      const atual = lista.find((item) => item.id === id)
      if (!atual) return lista
      const resto = lista.filter((item) => item.id !== id)
      const movido = { ...atual, coluna }
      if (!antesDe) return [...resto, movido]
      const idx = resto.findIndex((item) => item.id === antesDe)
      if (idx < 0) return [...resto, movido]
      const copia = [...resto]
      copia.splice(idx, 0, movido)
      return copia
    })
    setSobre('')
    setMarca(null)
  }

  function incluir() {
    const id = `n${Date.now()}`
    setItens((lista) => [
      { id, coluna: 'nao', titulo: 'Novo item', linha: 'Sem responsável' },
      ...lista,
    ])
  }

  return (
    <div className="erp-kanban">
      {COLUNAS.map((coluna) => {
        const daColuna = itens.filter((item) => item.coluna === coluna.id)
        return (
          <section
            key={coluna.id}
            className={`erp-kanban__col${sobre === coluna.id ? ' is-sobre' : ''}`}
            onDragOver={(event) => {
              event.preventDefault()
              setSobre(coluna.id)
            }}
            onDragLeave={(event) => {
              if (!event.currentTarget.contains(event.relatedTarget)) setSobre('')
            }}
            onDrop={(event) => {
              event.preventDefault()
              const id = event.dataTransfer.getData('text/plain') || arrastando.current
              if (id) mover(id, coluna.id)
            }}
          >
            <header className="erp-kanban__head">
              <h3>{coluna.nome}</h3>
              <span className="erp-kanban__acoes">
                {coluna.inclui && (
                  <button type="button" className="erp-kanban__mais" aria-label="Incluir na primeira coluna" onClick={incluir}>
                    +
                  </button>
                )}
                <span className="erp-kanban__contagem">{daColuna.length}</span>
              </span>
            </header>
            <div className="erp-kanban__lista">
              {!daColuna.length && <p className="erp-kanban__vazio">Nenhum item</p>}
              {daColuna.map((item) => {
                const posicao = marca && marca.id === item.id ? marca.posicao : ''
                return (
                  <article
                    key={item.id}
                    className={`erp-kanban__card${aberta === item.id ? ' is-aberta' : ''}${posicao === 'antes' ? ' is-antes' : ''}${posicao === 'depois' ? ' is-depois' : ''}`}
                    onDragOver={(event) => {
                      event.preventDefault()
                      event.stopPropagation()
                      const rect = event.currentTarget.getBoundingClientRect()
                      const posicaoCursor = event.clientY > rect.top + rect.height / 2 ? 'depois' : 'antes'
                      setMarca({ id: item.id, posicao: posicaoCursor })
                      setSobre(coluna.id)
                    }}
                    onDrop={(event) => {
                      event.preventDefault()
                      event.stopPropagation()
                      const id = event.dataTransfer.getData('text/plain') || arrastando.current
                      if (!id || id === item.id) return
                      const rect = event.currentTarget.getBoundingClientRect()
                      const depois = event.clientY > rect.top + rect.height / 2
                      const lista = itens.filter((outro) => outro.coluna === coluna.id && outro.id !== id)
                      const idx = lista.findIndex((outro) => outro.id === item.id)
                      const ancora = depois ? lista[idx + 1] : item
                      mover(id, coluna.id, ancora ? ancora.id : null)
                    }}
                  >
                    <div className="erp-kanban__topo">
                      <button
                        type="button"
                        className="erp-kanban__alca"
                        draggable
                        aria-label="Arrastar para mudar a ordem ou a coluna"
                        onDragStart={(event) => {
                          arrastando.current = item.id
                          event.dataTransfer.setData('text/plain', item.id)
                          event.dataTransfer.effectAllowed = 'move'
                        }}
                        onDragEnd={() => {
                          arrastando.current = ''
                          setSobre('')
                          setMarca(null)
                        }}
                      >
                        ⋮⋮
                      </button>
                      <p className="erp-kanban__titulo">{item.titulo}</p>
                      <button type="button" className="erp-kanban__editar" onClick={() => setAberta(item.id)}>
                        Editar
                      </button>
                    </div>
                    <p className="erp-kanban__linha">{item.linha}</p>
                  </article>
                )
              })}
            </div>
          </section>
        )
      })}
    </div>
  )
}
